import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './hooks';
import { CacheLookup, CachedEntity, fetchCountries, fetchApplications, fetchRoles } from './cacheSlice';

const useCache: (entity: CachedEntity) => CacheLookup[] = (entity: CachedEntity) => {
    const cache = useAppSelector(s => s.genericCache.cache[entity]);
    const pending = useAppSelector(s => s.genericCache.pending[entity]);
    const loaded = useAppSelector(s => s.genericCache.loaded?.[entity] ?? false);
    const isAuthenticated = useAppSelector(s => !!s.currentUser.data);
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Guard on `loaded`, not an empty cache — a legitimately empty result must not re-fetch every render.
        if (isAuthenticated && !loaded && !pending) {
            dispatch(fetchCountries());
            dispatch(fetchApplications());
            dispatch(fetchRoles());
        }
    });

    return cache;
}

export default useCache;
